import React, { useState, useEffect } from "react";
import {
  Button,
  FormFieldSet,
  useFormHandler,
} from "../../../../../../components";

const leadsOptions = [
  { label: "Ershad", value: "Ershad" },
  { label: "Farida", value: "Farida" },
  { label: "Hassan", value: "Hassan" },
];

const memberOptions = [
  { label: "Amina", value: "Amina" },
  { label: "Omar", value: "Omar" },
  { label: "Hassan", value: "Hassan" },
];

const CreateTeam = ({ onCancel }) => {
  const [validationRules, setValidationRules] = useState();

  const initialFormData = {
    teamName: "",
    lead: "",
    member: "",
  };

  useEffect(() => {
    const baseRules = {
      teamName: {
        type: "text",
        required: true,
      },
      lead: {
        type: "text",
        required: true,
      },
      member: {
        type: "text",
        required: true,
      },
    };
    setValidationRules(baseRules);
  }, []);

  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, validationRules);

  const handleSubmit = async () => {
    const isValid = await validateAllFields();
  };
  return (
    <div className="h-120 flex flex-col justify-between gap-3">
      <div className="flex flex-col gap-3">
        <div className="grid grid-cols-3 gap-3">
          <FormFieldSet
            type="text"
            title="Team Name"
            placeholder="Enter"
            value={formData.teamName}
            onChange={(value) => handleChange("teamName", value)}
            error={errors.teamName}
            shadow={true}
          />
        </div>
        <div className="grid grid-cols-3 gap-3">
          <FormFieldSet
            type="radioSelect"
            title="Lead"
            placeholder="Select"
            options={leadsOptions}
            value={formData.lead}
            onChange={(value) => handleChange("lead", value)}
            error={errors.lead}
            showSearch={true}
            shadow={true}
          />
          <FormFieldSet
            type="multiSelect"
            title="Member"
            placeholder="Select"
            options={memberOptions}
            value={formData.member}
            onChange={(value) => handleChange("member", value)}
            showSearch={true}
            showSelectAll={false}
            shadow={true}
          />
        </div>
      </div>
      <div className="flex self-end gap-3">
        <Button
          title={"Cancel"}
          variant="outlined"
          color="black"
          onClick={onCancel}
        />
        <Button title={"Save"} onClick={handleSubmit} />
      </div>
    </div>
  );
};

export default CreateTeam;
